module.exports = __webpack_public_path__ + "static/media/sykkel_blå-min.d090dde3.png";